export const app = {
    notification: 'Notifications',
    sidebar: {
        platform: {
            admin: 'Admins',
            notifications: 'Notifications',
            accessLog: {
                title: 'Access Logs',
                userLog: 'User logs',
                projectLog: 'Project logs',
                serverLog: 'Server logs',
                projectLogHistory: 'Project logs',
                projectLogTransaction: 'Project Log Transaction',
                projectLogReport: 'Project log report',
                projectLogServer: 'Log server',
            },
            help: 'Help',
        },
        constellation: {
            admin: {
                dashboard: 'Dashboard',
                project: 'Projects',
                notifications: 'Notifications',
                user: {
                    title: 'Admins',
                    user: 'Users',
                    group: 'Constellation Groups',
                    securityProfile: 'Constellation Profiles',
                    projectProfile: 'Project Profiles',
                },
                accessLogs: 'Access Logs',
                help: 'Help',
            },
            project: {
                dashboard: 'Dashboard',
                abs: 'ABS',
                admin: {
                    title: 'Admins',
                    user: 'Users',
                    group: 'Project Groups',
                    projectProfile: 'Project Profiles',
                    pbs: 'PBS',
                },
                notifications: 'Notifications',
                project: {
                    title: 'Projects',
                    ['3D']: '3D Viewer',
                    ['4DAnalyzer']: '4D Analyzer',
                    calendar: 'Calendar',
                    activityCode: 'Activity code',
                    userDefinedField: 'User defined field',
                    appearanceProfile: 'Appearance profile',
                    resource: 'Resource',
                },
                exitProject: 'Exit project',
            },
        },
        ['3DViewer']: {
            admin: {
                admin: {
                    title: 'Admins',
                    user: 'Users',
                    group: '3D Viewer Groups',
                    profile: '3D Viewer Profiles',
                },
                notifications: 'Notifications',
            },
            user: {
                ['3DViewer']: '3D Viewer',
                repository: 'Repository',
            },
        },
    },
    menuAccount: {
        myProfile: 'My profile',
        logout: 'Logout',
    },
    menuLanguage: {
        en: 'English',
        fr: 'French',
    },
    menuDateFormat: {
        HH_mm_DD_MM_YYYY_SLASH: 'HH:MM DD/MM/YYYY',
        HH_mm_AM_PM_DD_MM_YYYY_SLASH: 'HH:MM AM(PM) A DD/MM/YYYY',
        HH_mm_DD_MM_YYYY_DASH: 'HH:MM DD-MM-YYYY',
        HH_mm_AM_PM_DD_MM_YYYY_DASH: 'HH:MM AM(PM) DD-MM-YYYY',
        HH_mm_DD_MONTH_YYYY: 'HH:MM DD Month Name YYYY',
    },
    accessModule: {
        spacialytic_platform: 'Spacialytic Platform',
        spacialytic_3dwebviewer: 'Spacialytic 3d WebViewer',
        spacialytic_constellation: 'Spacialytic Constellation',
    },
    buttons: {
        cancel: 'Cancel',
        confirm: 'Confirm',
        yes: 'Yes',
        no: 'No',
        ok: 'Ok',
    },
    timezones: {
        ['GMT+00:00']:
            '(GMT+00:00) Casablanca, Dublin, Edinburgh, Lisbon, London, Monrovia, Reykjavik',
        ['GMT+01:00']:
            '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna, Brussels, Copenhagen, Madrid, Paris, Belgrade,Bratislava, Budapest, Ljubljana, Prague, Sarajevo, Skopje, Warsaw, Zagreb, West Central Africa',
        ['GMT+02:00']:
            '(GMT+02:00) Athens, Bucharest, Istanbul, Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius, Cairo, Jerusalem, Beirut, Amman, Minsk, Windhoek, Damascus, Harare, Pretoria',
        ['GMT+03:00']:
            '(GMT+03:00) Moscow, St. Petersburg, Volgograd, Kuwait, Riyadh, Nairobi, Baghdad',
        ['GMT+04:00']:
            '(GMT+04:00) Abu Dhabi, Muscat, Yerevan, Port Louis, Tbilisi, Baku',
        ['GMT+05:00']: '(GMT+05:00) Yekaterinburg, Islamabad, Karachi, Tashkent',
        ['GMT+06:00']: '(GMT+06:00) Dhaka, Novosibirsk, Astana',
        ['GMT+07:00']: '(GMT+07:00) Bangkok, Hanoi, Jakarta, Krasnoyarsk',
        ['GMT+08:00']:
            '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi, Kuala Lumpur, Singapore, Taipei, Perth, Ulaanbaatar, Irkutsk',
        ['GMT+09:00']: '(GMT+09:00) Seoul, Osaka,Sapporo, Tokyo, Yakutsk',
        ['GMT+10:00']:
            '(GMT+10:00) Canberra, Melbourne, Sydney, Brisbane, Guam, Port Moresby, Vladivostok, Hobart',
        ['GMT+11:00']: '(GMT+11:00) Magadan, Solomon Is.,New Caledonia',
        ['GMT+12:00']: '(GMT+12:00) Auckland, Wellington, Petropavlovsk-Kamchatsky, Fiji',
        ['GMT-01:00']: '(GMT-01:00) Cape Verde Is, Azores',
        ['GMT-02:00']: '(GMT-02:00) Mid-Atlantic',
        ['GMT-03:00']:
            '(GMT-03:00) Cayenne, Fortaleza, Buenos Aires, Brasilia, Montevideo, Greenland',
        ['GMT-04:00']:
            '(GMT-04:00) Atlantic Time (Canada), Georgetown, La Paz, Manaus, San Juan, Asuncion, Cuiaba, Santiago',
        ['GMT-05:00']: '(GMT-05:00) Bogota, Lima, Quito, Indiana (East)',
        ['GMT-06:00']:
            '(GMT-06:00) Guadalajara, Mexico City, Monterrey, Central America, Saskatchewan',
        ['GMT-07:00']: '(GMT-07:00) Chihuahua, Mazatlan, Arizona',
        ['GMT-08:00']: '(GMT-08:00) Baja California',
        ['GMT-09:00']: '(GMT-09:00) Alaska',
        ['GMT-10:00']: '(GMT-10:00) Hawaii',
        ['GMT-11:00']: '(GMT-11:00) Samoa',
    },
    month: {
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December',
    },
};
